import * as patients from '@seen/core/models/patients'
import { orderBy } from 'lodash-es'

// Isolation Required 0, Critical Attention 1, OOSA 2 occupy the pin ranks.
const PRIORITY_RANK: Record<patients.ParticipantFlagPriority, number> = {
  [patients.ParticipantFlagPriority.P0]: 3,
  [patients.ParticipantFlagPriority.P1]: 4,
  [patients.ParticipantFlagPriority.P2]: 5,
  [patients.ParticipantFlagPriority.P3]: 6,
}

export function sortParticipantFlagsBySeverity(
  flagCodes: readonly patients.ParticipantFlagCode[]
): patients.ParticipantFlagCode[] {
  return orderBy(
    flagCodes,
    [
      (code) => {
        if (code === patients.ParticipantFlagCode.ISOLATION_REQUIRED) {
          return 0
        }
        if (code === patients.ParticipantFlagCode.CRITICAL_ATTENTION) {
          return 1
        }
        if (code === patients.ParticipantFlagCode.OOSA) {
          return 2
        }
        return PRIORITY_RANK[patients.PARTICIPANT_FLAGS[code].priority]
      },
    ],
    ['asc']
  )
}
